require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 1375
// module chunks = 168707334958949